import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '../lib/api';
import { config } from '../lib/config';

export interface Profile {
  authenticated: boolean;
  sub?: string;
  email?: string;
  name?: string;
  activeSubscriptionId?: string | null;
}

async function fetchProfile(): Promise<Profile> {
  const res = await apiFetch('/api/v1/profile');
  if (res.status === 401) {
    return { authenticated: false };
  }
  if (!res.ok) {
    throw new Error(`profile request failed: ${String(res.status)}`);
  }
  // bff отдаёт либо «голый» объект (минимальный режим), либо конверт { data }.
  const body: unknown = await res.json();
  const data = (body as { data?: Profile }).data ?? (body as Profile);
  return { ...data, authenticated: true };
}

/**
 * useAuth — состояние текущей сессии (через bff `/api/v1/profile`).
 * Возвращает профиль + действия login/logout (полный redirect на bff endpoints).
 */
export function useAuth() {
  const query = useQuery({
    queryKey: ['profile'],
    queryFn: fetchProfile,
    staleTime: 60_000,
  });

  const login = (returnUrl: string = window.location.pathname): void => {
    window.location.href = `${config.apiBase}/auth/login?returnUrl=${encodeURIComponent(returnUrl)}`;
  };

  const logout = (): void => {
    window.location.href = `${config.apiBase}/auth/logout?returnUrl=/`;
  };

  return {
    profile: query.data,
    isAuthenticated: query.data?.authenticated ?? false,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
    login,
    logout,
  };
}
